var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video__object__player",
      attrs: { "data-ui-section": "video-main" }
    },
    [
      _c(
        "div",
        { staticClass: "video__object__player__video-container" },
        [
          _vm._t("video-player-pre-ready"),
          _vm._v(" "),
          _vm.showVideoPlayer
            ? [
                _c("VideoPlayer", {
                  ref: "videoPlayer",
                  staticClass: "stick-all-corners",
                  attrs: {
                    "video-source": _vm.videoStoreState.videoSource,
                    options: _vm.videoStoreState.videoPlayerOptions
                  },
                  on: {
                    ready: _vm.attemptToPlayVideo,
                    error: _vm.handlePlayerError,
                    setupError: _vm.handlePlayerError,
                    warning: _vm.handlePlayerWarning,
                    time: _vm.wrappedConsumeQuotaFn
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "controls",
                        fn: function() {
                          return [
                            !_vm.showVideoPlayerControls ? _c("span") : _vm._e()
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "default",
                        fn: function(ref) {
                          var player = ref.player
                          return [
                            _vm.showVideoPlayerControls && _vm.isMutedAutoStart
                              ? _c("VideoUnmuteOverlay", {
                                  on: { unmute: _vm.unmuteVideo }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("InPlayerOverlaysManager", {
                              attrs: { manifests: _vm.inPlayerOverlayManifests }
                            }),
                            _vm._v(" "),
                            player
                              ? _c("VideoTrackers", {
                                  attrs: {
                                    player: player,
                                    video: _vm.video,
                                    "tracker-options": _vm.trackerOptions
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3094058212
                  )
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("VideoPlayerOverlaysManager")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }